import { useState } from 'react';

import { createOrUpdateBorrower } from '@/apiCalls/borrower';
import { Button } from '@/components/Button';
import { ModalComponent } from '@/components/ModalComponent';
import { ModalHeader } from '@/components/ModalHeader';
import { selectLicenseNumber, selectLicenseState } from '@/context/borrower';
import { setModal } from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { BirthDate } from '@/UserInput/BirthDate';
import { LicenseExpiry } from '@/UserInput/LicenseExpiry';
import { LicenseNumber } from '@/UserInput/LicenseNumber';
import { LicenseState } from '@/UserInput/LicenseState';
import { isBirthDateValid } from '@/utils/checkBirthDate';
import { isLicenseExpiryDateValid } from '@/utils/checkLicenseExpiryDate';

export const testId = 'TDPersonalInformationModal';

export function TDPersonalInformationModal(): JSX.Element {
    // ***** Constants *****
    const baseId = 'modal-TDPersonalInformationModal';
    // ***** Local State *****
    const [showErrors, setShowErrors] = useState<boolean>(false);
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    const licenseNumber = useAppSelector(selectLicenseNumber);
    const licenseState = useAppSelector(selectLicenseState);

    // ***** Handlers *****
    function handleClick(): void {
        setShowErrors(true);
        if (!isComplete()) return;
        createOrUpdateBorrower();
        dispatch(setModal(null));
    }

    // ***** Helpers *****
    function isComplete(): boolean {
        // if (gender === null || gender === undefined) return false;
        if (!isBirthDateValid()) return false;
        if (licenseNumber === '' || licenseNumber === undefined) return false;
        if (licenseState === '' || licenseState === undefined) return false;
        if (!isLicenseExpiryDateValid()) return false;
        return true;
    }

    // ***** Render *****
    return (
        <ModalComponent baseId={baseId} data-testid={testId}>
            <ModalHeader title='Personal Information' baseId={baseId} />
            <LicenseNumber baseId={baseId} showErrors={showErrors} />
            <LicenseState baseId={baseId} showErrors={showErrors} />
            <LicenseExpiry baseId={baseId} showErrors={showErrors} />
            <BirthDate baseId={baseId} showErrors={showErrors} />
            <div className='py-2 mx-16'>
                <Button onClick={handleClick} id={`${baseId}-button-close`}>
                    <p>Save</p>
                </Button>
            </div>
        </ModalComponent>
    );
}
